module.exports = __webpack_public_path__ + "img/奖章5级@2x.7b3bbe30.png";